import { render, staticRenderFns } from "./SelectInputInner.vue?vue&type=template&id=2226a28b&scoped=true"
import script from "./SelectInputInner.vue?vue&type=script&lang=ts"
export * from "./SelectInputInner.vue?vue&type=script&lang=ts"
import style0 from "./SelectInputInner.vue?vue&type=style&index=0&id=2226a28b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226a28b",
  null
  
)

export default component.exports